<template>
  <section class="mt-3 top-deals-slider container-fluid mb-3" v-if="vehicles">
    <div class="d-flex align-items-center justify-content-center" style="height:415px;" v-if="loading">
      <loader text="Lade Top Deals ..."></loader>
    </div>

    <div v-if="vehicles.length">
      <h2 id="top-deals" class="text-center mb-0">Unsere Top Deals</h2>
      <h3 class="text-center">Eine Auswahl unserer Top Deals</h3>
      <swiper :options="swiperOptions" ref="topDealSwiper">
        <swiper-slide v-for="vehicle in vehicles" :key="vehicle.id">
          <top-deals-slider-entry :vehicle="vehicle"></top-deals-slider-entry>
        </swiper-slide>

        <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
      </swiper>
      <div class="swiper-pagination mt-3 mt-md-5"></div>

      <div class="text-center mt-3 mt-md-5">
        <a :href="catalogUrl" class="btn btn-dark">Alle Top Deals im Katalog ansehen</a>
      </div>
    </div>
  </section>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import {swiper, swiperSlide} from "vue-awesome-swiper";
import TopDealsSliderEntry from "./TopDealsSliderEntry";

export default {
  name: "TopDealsSlider",
  components: {
    TopDealsSliderEntry,
    swiper,
    swiperSlide
  },
  props: {
    catalogUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      vehicles: [],
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          bulletClass: 'bullet-icon',
          bulletActiveClass: 'active',
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
          }
        },
        watchOverflow: true,
        touchRatio: 0,
        centeredSlides: true,
        initialSlide: 1,
        slideToClickedSlide: false,
        slideOffsetBefore: 0,
        slideOffsetAfter: 0,
        loop: true,
        slidesPerView: 3,
        spaceBetween: 70,
        noSwiping: true,
        breakpointsBase: 'container',
        breakpoints: {
          // // when window width is >= 320px

          // // when window width is >= 480px
          768: {
            slidesPerView: 1,
            loopedSlides: 0,
            spaceBetween: 70,
            noSwiping: false,
            slideOffsetBefore: 0,
            slideOffsetAfter: 0,
          },
          992: {
            slidesPerView: 2,
            loopedSlides: 0,
            spaceBetween: 70,
            noSwiping: false,
            slideOffsetBefore: 0,
            slideOffsetAfter: 0,
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    randomOrder: function(rand){
      return rand.sort(function(){return 0.5 - Math.random()});
    },
    loadDeals(){
      axios.get("/api/v1.0/vehicles?topDeals=true&random=true&per_page=20&page=1")
          .then(result => {
            this.vehicles = this.randomOrder(result.data.data)
            this.disableLoader();
          })
          .catch(error => {
            console.warn(error.message)
          });
    },
    disableLoader(){
      this.loading = false;
    },
  },
  mounted: function () {
    this.loadDeals()
  }
};
</script>

<style scoped lang="scss">

.swiper-pagination {
  position: relative;
}

.swiper-container {
  padding: 20px 50px;
  //padding-left: 50px;
  //padding-right: 50px;
  //padding-bottom: 20px;
  //padding-top: 20px;
}

.dark-button {
  background: #000;
  color: #fff;
  height: 40px !important;
  padding-top: 8px;
}

</style>
